export const FILE_PATH_OS = {
    QRCODE: '/opt/amwell/config/app/QRCODE',
    DOMAIN: '/opt/amwell/config/app/DOMAIN',
    APP_LOG: '/opt/amwell/log/app/app.log',
};
export const VALIDATORS = {
    IP_VALIDATOR:
        '^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$',
    PREFIX_VALIDATOR: '^(3[0-2]|[12][0-9]|[1-9])$',
};
